
export const SET_EXAGO_LOADING = 'SET_EXAGO_LOADING';
export const SET_EXAGO_SESSION = 'SET_EXAGO_SESSION';
export const SET_EXAGO_ERROR = 'SET_EXAGO_ERROR';
export const SET_FETCHING_HIRINGCLIENTS = 'SET_FETCHING_HIRINGCLIENTS';